module.exports = __webpack_public_path__ + "media/images/countryrect/tg-12ab07a50227d7adc04575f4b3ed96e7.svg";